import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateBlockListEmployer = {
  blockListEmployer: { data: null, loading: false, error: null },
};

export const blockListEmployer = createAsyncThunk('user/blockListEmployer', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .put(`${process.env.REACT_APP_SERVER_API}/employers/blocked`, data, {
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerBlockListEmployer = {
  [blockListEmployer.pending]: (state) => {
    state.blockListEmployer.loading = true;
    state.blockListEmployer.error = null;
  },
  [blockListEmployer.fulfilled]: (state, action) => {
    state.blockListEmployer.loading = false;
    state.blockListEmployer.data = true;
    state.blockListEmployer.error = null;
  },
  [blockListEmployer.rejected]: (state, action) => {
    state.blockListEmployer.loading = false;
    state.blockListEmployer.error = action.payload;
  },
};
